import { render, staticRenderFns } from "./StatusFilterChips.vue?vue&type=template&id=0bb34e7e&scoped=true"
import script from "./StatusFilterChips.vue?vue&type=script&lang=ts"
export * from "./StatusFilterChips.vue?vue&type=script&lang=ts"
import style0 from "./StatusFilterChips.vue?vue&type=style&index=0&id=0bb34e7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb34e7e",
  null
  
)

export default component.exports